import { ApiHelper } from './apiHelper';
import {
  CallMeBackEmailContent,
  EmailResponse
} from '../components/common/CommonTypes';

export class EmailApi {
  async CallMeBackEmailAsync(
    data: CallMeBackEmailContent,
    token: string,
    successCallback: (response: EmailResponse) => void,
    failureCallback: (response: EmailResponse) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/email/callme';

    await new ApiHelper().postDataWithResponseSecure(
      dataUrl,
      data,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
